import React from 'react'
import styles from './styles.module.scss'
import { useShoppingCart } from '@/src/context/shopping-cart/shopping-cart-context'
import '@/src/extensions/number'
import { useMerchant } from '@/src/context/merchant/merchant-context'
import LoadingCartProduct from './loading-cart-product/loading-cart-product'
import ApplyCoupon from '../apply-coupon/apply-coupon'
import SvgTrash from '@/src/assets/svgs/collection/trash.svg'
import BaseLoading from '@/src/components/helpers/base-loading/base-loading'
import ImageFallback from '@/src/components/helpers/image-fallback/image-fallback'
import AddMore from '@/src/components/product/add-more/add-more'
import ItemsTree from '@/src/components/product/items-tree/items-tree'
import NoItems from '../../misc/no-items/no-items'

export default function ShoppingCartItems() {
    const { merchantSummary } = useMerchant()
    const { shoppingCart, deleteProduct, updateProduct } = useShoppingCart()

    const renderProducts = () => {
        if (!shoppingCart) {
            return (
                <BaseLoading>
                    <LoadingCartProduct />
                </BaseLoading>
            )
        }
        else if (shoppingCart?.items && shoppingCart.items.length > 0) {
            return (
                <>
                    {
                        shoppingCart.items.map((item, index) => {
                            const imgSrc = (item.hasPhoto && merchantSummary?.showProductPhoto) ? `//${item?.smallImageUrl}` : undefined

                            return (
                                <div key={index} className={styles.item}>
                                    <div className={styles.topRow}>
                                        <div className={styles.imageArea}>
                                            <ImageFallback
                                                src={imgSrc}
                                                alt={item.personalizedName ?? item.name}
                                            />
                                        </div>
                                        <ItemsTree isDrawer titleFontSize='font-xmd' itemsFontSize='font-md' cartItem={item} />
                                        <div onClick={() => deleteProduct(index)} className={styles.deleteArea}>
                                            <SvgTrash />
                                        </div>
                                    </div>
                                    <div className={styles.bottomRow}>
                                        <div className={styles.alignElement} />
                                        {
                                            (!item.isGroup && !item.loyaltyCampaignId) &&
                                            <AddMore value={item.quantity} setValue={(a) => updateProduct(item, a, index)} theme='inverted' border='radius' />
                                        }
                                        <span className={`${styles.price} font-xmd`}>{item.totalPrice!.toLocalePrice()}</span>
                                    </div>
                                </div>
                            )
                        })
                    }
                </>
            )
        }
        else {
            return (
                <NoItems
                    type='bag'
                    message='Sua sacola está vazia.'
                />
            )
        }
    }

    return (
        <div className={styles.container}>
            {renderProducts()}
            {
                shoppingCart && shoppingCart?.items.length > 0 &&
                <ApplyCoupon />
            }
        </div>
    )
}
